<template>
  <a-drawer
    :maskClosable="false"
    width="40%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <template v-if="showId === 1">
        <a-form-model-item label="审核状态" prop="status">
          <a-radio-group button-style="solid" v-model="form.status">
            <a-radio-button :value="1"> 通过 </a-radio-button>
            <a-radio-button :value="2"> 打回 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="回复内容" prop="rreviewerEply" v-if="form.status == 2">
          <a-input v-model="form.rreviewerEply" style="width: 500px" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
      </template>
      <template v-if="showId === 2">
        <a-form-model-item label="备注" prop="shopRemarks">
          <a-input v-model="form.shopRemarks" style="width: 500px" placeholder="请输入" type="textarea" allow-clear />
        </a-form-model-item>
      </template>
      <template v-else-if="showId === 3">
        <a-form-model-item label="配送类型" prop="dvyType">
          <a-radio-group v-model="form.dvyType" button-style="solid">
            <a-radio-button :value="1"> 物流 </a-radio-button>
            <a-radio-button :value="2"> 自提 </a-radio-button>
            <a-radio-button :value="3">无需快递 </a-radio-button>
            <a-radio-button :value="4">线下配送 </a-radio-button>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="物流单号	" prop="dvyFlowId" v-if="form.dvyType == 1">
          <a-input v-model="form.dvyFlowId" placeholder="请输入" :maxLength="36" />
        </a-form-model-item>
      </template>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>
<script>
import { cancelObj, putObj, reviewPay, addObj, getObj } from '@/api/declaration/declarationOrder'
import moment from 'moment'
import Examine from './examine'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: { Examine },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        status: 1,
        remarkVal: undefined,
      },
      isShow: false,
      open: false,
      inspector: [],
      showId: 1,
      info: {},
      rules: {
        dvyFlowId: [{ required: true, message: '请输入物流单号', trigger: 'blur' }],
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        vrFiles: [{ required: true, message: '请上传VR文件', trigger: 'blur' }],
        vrUrl: [{ required: true, message: '请输入VR地址', trigger: 'blur' }],
        rreviewerEply: [{ required: true, message: '请输入回复内容', trigger: 'blur' }],
        shopRemarks: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {
    // 时间选择
    onChange(e) {
      this.form.reservationTime = moment(e).format('YYYY-MM-DD HH:mm')
    },
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },
    // 查询验收和水工
    getUserList(type) {
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        acceptStatus: 2,
        remarkVal: undefined,
      }
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加预约订单'
    },
    // 验收员选择发生变化
    handleChange(e) {
      this.inspector.forEach((v) => {
        if (v.userId === e) {
          this.form.pressureTestName = v.userName
          this.form.pressureTestUserPhone = v.userPhone
        }
      })
    },
    /** 修改按钮操作 */
    init(row, index) {
      // this.reset()
      // this.form.id = row.id
      this.open = true
      this.showId = index
      if (index === 1) {
        this.formTitle = '审核'
        this.form = {
          status: 1,
          rreviewerEply: '',
          orderId: row.orderId,
        }
        // this.info=row
      } else if (index === 2) {
        this.formTitle = '备注'
        this.form = {
          shopRemarks: '',
          orderId: row.orderId,
        }
        // getObj(row.id).then((response) => {
        //   this.form = response.data
        //   this.form.params = response.data.reportInfoResult.productModelResults
        //   this.form = {
        //     params: response.data.reportInfoResult.productModelResults,
        //     id: row.id,
        //   }
        // })
        // this.form.params = [{ name: '' }],
      } else if (index === 3) {
        this.formTitle = '发货'
        this.form = {
          dvyFlowId: '',
          dvyType: 1,
          orderId: row.orderId,
        }
      }
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.showId === 1) {
            reviewPay(this.form)
              .then((response) => {
                this.$message.success('审核成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else if (this.showId === 2) {
            addObj(this.form)
              .then((response) => {
                this.$message.success('备注成功', 3)
                this.open = false
                this.$emit('ok')
                this.$emit('changeStatus')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          } else {
            putObj(this.form)
              .then((response) => {
                this.$message.success('发货成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
                this.showLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
</style>
